export function BeforeYouReachOut({ providerName }: { providerName?: string }) {
    return (
        <p
            data-reach-out
            className="mt-3 text-center font-family-body text-sm leading-normal tracking-[-0.16px] text-balance text-doberman-black/60"
        >
            Kits asks {providerName || "the breeder or shelter"} for you. You
            hear back by text.
        </p>
    );
}
